import {NativeStackHeaderProps} from "@react-navigation/native-stack";
import {StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";
import {useEvent} from "@/lib/components/EventProvider";
import EventHeader from "@/lib/components/EventHeader";
import {useGroup} from "@/lib/components/GroupProvider";
import GroupHeader from "@/lib/components/GroupHeader";
import {useProfile} from "@/lib/components/ProfileProvider";
import ProfileHeader from "@/lib/components/ProfileHeader";
import {useChat} from "@/lib/components/ChatProvider";
import ChatHeader from "@/lib/components/ChatHeader";

export default function WebHeader(props: NativeStackHeaderProps) {
    const {event} = useEvent();
    const {group} = useGroup();
    const {profile} = useProfile();
    const {currentChat} = useChat();

    return (
        <View style={styles.outer}>
            <View style={styles.container}>
                <Text style={styles.title}>{props.options.title}</Text>
                {!!props.options.headerRight &&
                    <View style={styles.headerRight}>
                        {event && <EventHeader/>}
                        {group && <GroupHeader/>}
                        {profile && <ProfileHeader/>}
                        {currentChat && <ChatHeader/>}
                    </View>
                }
            </View>
        </View>
    )
}

export const styles = StyleSheet.create({
    outer: {
        width: "100%",
        backgroundColor: Color.Background,
    },
    container: {
        width: "100%",
        maxWidth: 664,
        marginHorizontal: "auto",
        backgroundColor: Color.Background,
        height: 91,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingVertical: 12,
        gap: 8,
    },
    title: {
        fontSize: 24,
        fontWeight: 500,
        color: Color.PrimaryText,
    },
    headerRight: {
        position: "absolute",
        right: 0,
    },
})